<template>
    <div class="checkbox" :class="classes">
        <input
            class=""
            type="checkbox"
            :checked="value"
            :name="id"
            :id="id"
            @change="$emit('input', !value)"
        />
        <label 
            class="checkbox__label" 
            :aria-checked="value" 
            role="checkbox" 
            tabindex="0" 
            :for="id" 
            :class="{'checkbox--active' : value}"
            :aria-label="ariaLabel"
            @keypress.space.prevent="$emit('input', !value)" 
        >
            <span class="checkbox__graphic bg--white">
                <svg v-if="value" class="icon--tick" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background: new 0 0 512 512;" xml:space="preserve">
                    <polygon fill="#009623" points="235.472,392.08 114.432,297.784 148.848,253.616 223.176,311.52 345.848,134.504 391.88,166.392 " />
                </svg>
            </span>
        </label>
    </div>
</template>

<script>

export default {
    data: () => ({
        id: Math.floor(Math.random() * 10000)
    }),

    props: {
        value: {
            type: Boolean,
            default: false
        },
        ariaLabel: {
            type: String,
            default: ''
        },
        classes: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss">

.checkbox {
    display: flex;

    .disclaimer & {
        align-items: center;
        position: relative;
        width: 48px;
        padding: 16px;
        border-radius: 5px 0 0 5px;
        border: 1px solid;
        border-color: #BBB3B3;
        border-right: 0;
        transition: background-color 0.2s, border-color 0.2s;
    }
    .disclaimer.disclaimer--active & {
        background: #34A34E;
        border-color: #34A34E;
    }
}

.checkbox__label {
    .disclaimer & {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
}

.checkbox__graphic {
    display: inline-block;
    position: relative;
    overflow: hidden;
    width: 20px;
    height: 20px;
    border: 1px solid #d5d5d5;
    border-radius: 5px;
}
</style>
